import React from 'react';
import { View, Text } from 'react-native';
import type { FeedbackStatus } from '@/lib/admin/types';
import { useThemeColors } from '@/lib/useThemeColors';

const STATUS_CONFIG: Record<FeedbackStatus, { label: string; color: string }> = {
  new: { label: 'New', color: '#00B8B8' },
  in_review: { label: 'In Review', color: '#FF9500' },
  resolved: { label: 'Resolved', color: '#34C759' },
  closed: { label: 'Closed', color: '#8E8E93' },
};

interface FeedbackStatusBadgeProps {
  status: FeedbackStatus;
  size?: 'sm' | 'md';
}

export function FeedbackStatusBadge({ status, size = 'sm' }: FeedbackStatusBadgeProps) {
  const config = STATUS_CONFIG[status];
  const isSmall = size === 'sm';

  return (
    <View
      className={`flex-row items-center gap-1.5 rounded-lg ${isSmall ? 'px-2 py-0.5' : 'px-3 py-1'}`}
      style={{ backgroundColor: `${config.color}15` }}
    >
      <View
        className="w-2 h-2 rounded-full"
        style={{ backgroundColor: config.color }}
      />
      <Text
        style={{ color: config.color }}
        className={`font-semibold ${isSmall ? 'text-[10px]' : 'text-xs'}`}
      >
        {config.label}
      </Text>
    </View>
  );
}
